import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { Reveal, StaggerItem } from "@/components/Reveal";
import teaserMegafon from "@/assets/brand/teaser_megafon.png";
import teaserBanner from "@/assets/brand/teaser_banner.png";

const MerchDropTeaser = () => {
  const { t } = useLang();
  const d = t.dropTeaser;

  const cards = [
    { img: teaserMegafon, title: d.card1Title, sub: d.card1Sub, n: "01", span: "md:col-span-3", ratio: "aspect-[16/9]" },
    { img: teaserBanner, title: d.card2Title, sub: d.card2Sub, n: "02", span: "md:col-span-2", ratio: "aspect-[4/3]" },
  ];

  return (
    <section className="bg-peach border-b border-ink py-20 md:py-28 relative overflow-hidden" data-testid="merch-drop-teaser">
      <div className="max-w-[1440px] mx-auto px-4 md:px-8">
        <Reveal>
          <p className="kicker text-pink">{d.kicker}</p>
          <h2 className="display uppercase text-5xl md:text-7xl lg:text-8xl leading-[0.85] mt-3 text-brand" data-testid="drop-teaser-title">
            <span>{d.title1}</span>
            <br />
            <span>{d.title2}</span>
          </h2>
          <p className="mt-6 max-w-xl text-lg font-medium text-ink/70">{d.sub}</p>
        </Reveal>

        <StaggerItem className="mt-12">
          <div className="grid md:grid-cols-5 gap-px bg-ink border border-ink">
            {cards.map((c) => (
              <Link key={c.n} to="/shop" className={`group bg-cream block ${c.span}`} data-testid={`drop-teaser-card-${c.n}`}>
                <div className={`relative overflow-hidden border-b border-ink ${c.ratio}`}>
                  <img
                    src={c.img}
                    alt={c.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                  />
                </div>
                <div className="p-5 flex items-end justify-between gap-4">
                  <div>
                    <p className="display uppercase text-2xl md:text-3xl leading-none">{c.title}</p>
                    <p className="text-sm font-medium text-ink/60 mt-1.5">{c.sub}</p>
                  </div>
                  <span className="display text-3xl md:text-4xl text-pink leading-none">{c.n}</span>
                </div>
              </Link>
            ))}
          </div>
        </StaggerItem>

        <Reveal className="mt-10">
          <Link to="/shop" data-testid="drop-teaser-cta" className="btn-primary h-14 px-8 inline-flex text-base">
            {d.cta} <ArrowRight className="w-5 h-5" strokeWidth={2} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};

export default MerchDropTeaser;
